import shampoo200 from "../images/200ml_shampoo.png";
import shampoo100 from "../images/100ml_shampoo.png";
import vitalizer from "../images/tonic.png";

export const productDetails = [
  {
    id: 1,
    name: "Rammyaa Arnica Anti Hairfall and Anti Dandruff Shampoo 200 mL",
    size: "200 ml",
    description:
      "Our flagship Arnica shampoo deeply cleanses while reducing hair fall and dandruff. Paraben, urea and salt free with a balanced pH for everyday care.",
    img: shampoo200,
    amazonLink:
      "https://www.amazon.in/Rammyaa-Arnica-Hairfall-Dandruff-Shampoo/dp/B0HCLT9KHQ/ref=lp_27943762031_1_1",
    meeshoLink: "https://www.meesho.com/s/p/gz8x5v?utm_source=s_w",
  },
  {
    id: 2,
    name: "Rammyaa Arnica Anti Hairfall and Anti Dandruff Shampoo 100mL",
    size: "100 mL",
    description:
      "The travel-friendly bottle of our bestseller. Strengthens roots, soothes an itchy scalp and leaves hair visibly softer and shinier.",
    img: shampoo100,
    amazonLink:
      "https://www.amazon.in/Rammyaa-Arnica-Dandruff-Hairfall-Shampoo/dp/B0HCLRR2Y1/ref=lp_27943762031_1_2",
    meeshoLink: "https://www.meesho.com/s/p/gz7ys7?utm_source=s_w",
  },
  {
    id: 3,
    name: "Rammyaa Rosemary Biotin Arnica Hair Vitalizer",
    size: "100 ml",
    description:
      "A lightweight leave-in spray with rosemary, biotin and Arnica extract that nourishes follicles and supports thicker-looking regrowth. For all hair types.",
    img: vitalizer,
    amazonDisabled: true,
    meeshoLink: "https://www.meesho.com/rammyaa-rosemary-biotin-hair-vitaliser/p/hnqyzu",
  },
];
